// src/merch/sheetLogo.js
//
// MerchMod logo as raw PDF path operators (dark grey + white), for the
// printable colouring sheets — vector, so it prints crisp, and grey so
// parents don't spend colour ink on it. Traced from Shep's sheet artwork.
// Local units: PDF points, origin = top-left of the logo, y UP (so the
// logo extends into negative y). Size: ~71 × 44 pt.

export const SHEET_LOGO_W = 71.4;
export const SHEET_LOGO_H = 44.2;

export const SHEET_LOGO_OPS = `
0.251 g
1.29 0.23 m
69.56 0.23 l
70.52 0.23 71.3 -0.55 71.3 -1.5 c
71.3 -42.23 l
71.3 -43.19 70.52 -43.97 69.56 -43.97 c
1.29 -43.97 l
0.33 -43.97 -0.45 -43.19 -0.45 -42.23 c
-0.45 -1.5 l
-0.45 -0.55 0.33 0.23 1.29 0.23 c
f
1 g
15.25 -27.54 m
17.67 -27.54 l
19.39 -23.62 l
19.18 -23.38 18.88 -23.22 18.53 -23.22 c
18.09 -23.22 17.7 -23.46 17.5 -23.83 c
17.3 -23.46 16.91 -23.22 16.47 -23.22 c
16.03 -23.22 15.65 -23.46 15.45 -23.83 c
15.26 -23.46 14.87 -23.22 14.43 -23.22 c
14.07 -23.22 13.76 -23.39 13.55 -23.65 c
h
15.25 -27.54 m
f
1 g
58.77 -31.78 m
58.05 -32.59 57.04 -32.99 55.72 -32.99 c
54.17 -32.99 l
54.17 -23.22 l
55.72 -23.22 l
57.04 -23.22 58.05 -23.62 58.77 -24.43 c
59.47 -25.24 59.83 -26.47 59.83 -28.12 c
59.83 -29.75 59.48 -30.97 58.77 -31.78 c
44.89 -20.24 m
43.97 -19.51 42.91 -18.96 41.7 -18.6 c
38.65 -13.86 l
39.43 -13.62 40.06 -13.21 40.56 -12.66 c
40.65 -14.79 41.35 -16.4 42.67 -17.5 c
43.86 -18.5 45.49 -19 47.38 -19 c
47.59 -19 47.81 -18.99 48.02 -18.97 c
48.02 -26.41 l
47.74 -23.76 46.71 -21.7 44.89 -20.24 c
40.57 -31.85 m
39.95 -32.96 39.04 -33.52 37.83 -33.52 c
36.59 -33.52 35.65 -32.96 35.03 -31.85 c
34.48 -30.88 34.21 -29.55 34.21 -27.86 c
34.21 -26.43 34.5 -25.26 35.06 -24.32 c
35.7 -23.25 36.62 -22.72 37.83 -22.72 c
39.04 -22.72 39.96 -23.25 40.6 -24.32 c
41.14 -25.24 41.42 -26.42 41.42 -27.86 c
41.42 -29.53 41.14 -30.86 40.57 -31.85 c
30.71 -20.27 m
28.79 -21.8 27.75 -24.02 27.57 -26.91 c
27.57 -18.65 l
33.8 -18.65 l
32.63 -19.01 31.6 -19.55 30.71 -20.27 c
24.31 -13.52 m
29.12 -13.52 l
29.12 -10.78 l
24.31 -10.78 l
24.31 -9.08 l
29.78 -9.08 l
29.78 -15.57 l
24.31 -15.57 l
h
35.24 -14.54 m
37.03 -18.11 l
35.88 -18.16 34.82 -18.33 33.86 -18.63 c
33.86 -14.54 l
h
33.87 -9.08 m
35.59 -9.08 l
36.07 -9.08 36.45 -9.2 36.71 -9.44 c
36.99 -9.69 37.12 -9.95 37.12 -10.27 c
37.12 -10.59 36.99 -10.87 36.71 -11.11 c
36.45 -11.34 36.07 -11.46 35.59 -11.46 c
33.87 -11.46 l
h
45.68 -9.81 m
46.09 -9.1 46.66 -8.75 47.38 -8.75 c
47.86 -8.75 48.26 -8.83 48.6 -9 c
49.22 -9.32 49.61 -9.92 49.76 -10.78 c
49.76 -10.78 l
53.2 -10.78 l
53.2 -13.51 l
49.76 -13.51 l
49.49 -14.56 49.18 -15.22 48.82 -15.5 c
48.46 -15.78 47.98 -15.91 47.38 -15.91 c
46.64 -15.91 46.06 -15.54 45.63 -14.79 c
45.26 -14.12 45.07 -13.3 45.07 -12.33 c
45.07 -11.36 45.28 -10.52 45.68 -9.81 c
53.2 -18.58 m
50.06 -18.58 l
50.75 -18.34 51.37 -18 51.9 -17.55 c
52.45 -17.09 52.88 -16.53 53.2 -15.89 c
h
9.56 -18.58 m
9.56 -14.54 l
9.21 -12.16 l
11.24 -18.58 l
h
63.51 -20.74 m
61.86 -19.3 59.95 -18.58 57.79 -18.58 c
57.29 -18.58 l
57.29 -13.52 l
60.72 -13.52 l
60.72 -18.65 l
64.8 -18.65 l
64.8 -6 l
60.72 -6 l
60.72 -10.78 l
57.29 -10.78 l
57.29 -6 l
53.2 -6 l
53.2 -8.5 l
52.82 -7.82 52.31 -7.25 51.64 -6.8 c
50.5 -6.04 49.08 -5.66 47.38 -5.66 c
45.43 -5.66 43.85 -6.15 42.65 -7.11 c
42.09 -7.56 41.65 -8.09 41.32 -8.71 c
41.1 -8.19 40.75 -7.71 40.28 -7.29 c
39.3 -6.43 37.96 -6 36.27 -6 c
20.55 -6 l
20.55 -18.58 l
20.55 -18.58 l
20.55 -22.56 l
20.56 -22.56 l
20.16 -23.46 l
17.05 -30.57 l
16.46 -31.91 l
15.88 -30.57 l
12.77 -23.46 l
12.38 -22.56 l
12.38 -18.65 l
14.09 -18.65 l
16.05 -12.16 l
15.7 -14.54 l
15.64 -18.65 l
17.11 -18.65 l
17.11 -21.67 l
17.11 -22.04 17.41 -22.34 17.78 -22.34 c
17.99 -22.34 l
18.36 -22.34 18.65 -22.04 18.65 -21.67 c
18.65 -18.65 l
19.84 -18.65 l
19.84 -6 l
15.02 -6 l
12.64 -14.21 l
10.59 -6 l
5.45 -6 l
5.45 -18.58 l
5.43 -18.58 l
5.43 -37.63 l
11.62 -37.63 l
11.62 -32.19 l
10.14 -27.52 l
14.18 -37.63 l
18.29 -37.63 l
22.34 -27.52 l
20.86 -32.19 l
20.86 -37.63 l
27.57 -37.63 l
27.57 -28.85 l
27.75 -31.93 28.8 -34.29 30.74 -35.91 c
32.53 -37.4 34.93 -38.15 37.83 -38.15 c
40.73 -38.15 43.08 -37.39 44.89 -35.88 c
46.71 -34.36 47.74 -32.19 48.02 -29.39 c
48.02 -37.63 l
57.79 -37.63 l
59.95 -37.63 61.86 -36.91 63.51 -35.47 c
65.53 -33.72 66.54 -31.27 66.54 -28.12 c
66.54 -24.97 65.53 -22.51 63.51 -20.74 c
f
1 g
14.98 -22.34 m
15.35 -22.34 15.65 -22.04 15.65 -21.67 c
15.65 -18.66 l
14.09 -18.66 l
14.09 -21.67 l
14.09 -22.04 14.39 -22.34 14.76 -22.34 c
h
14.98 -22.34 m
f
`;
